"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _helpers = require("@paprika/helpers");

var _ListBox = _interopRequireWildcard(require("./ListBox"));

var _Divider = _interopRequireDefault(require("./components/Divider"));

var _BoxShell = _interopRequireDefault(require("./components/Box/BoxShell"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _Filter = _interopRequireDefault(require("./components/Filter"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _Option = _interopRequireDefault(require("./components/Option"));

var _Popover = _interopRequireDefault(require("./components/Popover"));

var _RawItem = _interopRequireDefault(require("./components/RawItem"));

var _Trigger = _interopRequireDefault(require("./components/Trigger"));

var _A11y = _interopRequireDefault(require("./components/A11y"));

var _Provider = _interopRequireDefault(require("./store/Provider"));

var _OnChangeProvider = _interopRequireDefault(require("./store/OnChangeProvider"));

var _PropsProvider = _interopRequireDefault(require("./store/PropsProvider"));

var types = _interopRequireWildcard(require("./types"));

var _excluded = ["children", "hasError", "isDisabled", "isInline", "isReadOnly", "placeholder", "size", "contentOffsetX", "contentOffsetY"],
    _excluded2 = ["id", "refLabel"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ListBoxWithProvider = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      hasError = props.hasError,
      isDisabled = props.isDisabled,
      isInline = props.isInline,
      isReadOnly = props.isReadOnly,
      placeholder = props.placeholder,
      size = props.size,
      contentOffsetX = props.contentOffsetX,
      contentOffsetY = props.contentOffsetY,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var I18n = (0, _useI18n["default"])();
  /*
    Assures the structure of the children is one of the following:
     <React.Fragment>
      <ListBox.Option />
    </React.Fragment>
     - OR -
     [
      <React.Fragment>
        <ListBox.Option />
      </React.Fragment>,
      <React.Fragment>
        <ListBox.Option />
      </React.Fragment>
    ]
  */

  var _children = _react["default"].Children.map(children, function (child) {
    return child !== null && _react["default"].Fragment === child.type ? child.props.children : child;
  });

  var _extractChildren = (0, _helpers.extractChildren)(_children, ["ListBox.Box", "ListBox.Filter", "ListBox.Footer", "ListBox.Popover", "ListBox.Trigger", "ListBox.Content"]),
      box = _extractChildren["ListBox.Box"],
      filter = _extractChildren["ListBox.Filter"],
      footer = _extractChildren["ListBox.Footer"],
      popover = _extractChildren["ListBox.Popover"],
      trigger = _extractChildren["ListBox.Trigger"],
      content = _extractChildren["ListBox.Content"],
      options = _extractChildren.children;

  var a11yProps = (0, _helpers.extractChildrenProps)(_children, _A11y["default"]);
  var id = a11yProps.id,
      refLabel = a11yProps.refLabel,
      moreA11yProps = (0, _objectWithoutProperties2["default"])(a11yProps, _excluded2);
  var providedProps = {
    a11yProps: moreA11yProps,
    hasError: hasError,
    idListBox: id || "list-box_".concat((0, _uuid.v4)()),
    isDisabled: isDisabled,
    isInline: isInline,
    isReadOnly: isReadOnly,
    placeholder: placeholder || I18n.t("listBox.trigger.placeholder"),
    refLabel: refLabel,
    size: size,
    contentOffsetX: contentOffsetX,
    contentOffsetY: contentOffsetY
  };
  return /*#__PURE__*/_react["default"].createElement(_Provider["default"], (0, _extends2["default"])({}, moreProps, {
    childrenOptions: options
  }), /*#__PURE__*/_react["default"].createElement(_OnChangeProvider["default"], {
    onChange: props.onChange
  }, /*#__PURE__*/_react["default"].createElement(_PropsProvider["default"], providedProps, /*#__PURE__*/_react["default"].createElement(_ListBox["default"], (0, _extends2["default"])({}, moreProps, {
    box: box,
    filter: filter,
    footer: footer,
    popover: popover,
    trigger: trigger,
    content: content,
    ref: ref
  }), options))));
});

var _default = ListBoxWithProvider;
exports["default"] = _default;
ListBoxWithProvider.A11y = _A11y["default"];
ListBoxWithProvider.Box = _BoxShell["default"];
ListBoxWithProvider.Divider = _Divider["default"];
ListBoxWithProvider.Filter = _Filter["default"];
ListBoxWithProvider.Footer = _Footer["default"];
ListBoxWithProvider.Option = _Option["default"];
ListBoxWithProvider.Popover = _Popover["default"];
ListBoxWithProvider.RawItem = _RawItem["default"];
ListBoxWithProvider.Trigger = _Trigger["default"];
ListBoxWithProvider.Content = _Content["default"];
ListBoxWithProvider.displayName = "ListBox";
ListBoxWithProvider.propTypes = _ListBox.propTypes;
ListBoxWithProvider.defaultProps = _ListBox.defaultProps;
ListBoxWithProvider.types = {
  size: {
    SMALL: types.SMALL,
    MEDIUM: types.MEDIUM,
    LARGE: types.LARGE
  },
  kind: {
    MINOR: types.MINOR,
    PRIMARY: types.PRIMARY
  }
};
//# sourceMappingURL=index.js.map